/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { toast } from 'react-hot-toast' // Npm: React hot toast.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { useMutation } from '@apollo/client' // Npm: Apollo client.


/*
 * PACKAGES
 */
import DeleteCard from 'components/DeleteCard'


/*
 * GRAPHS
 */
import CustomerAccountDeleteMutation from './__mutation__/index.customerAccount.delete.mutation'
import CustomerAccountDeleteAllMutation from './__mutation__/index.customerAccount.deleteall.mutation'

/*
 * OBJECTS
 */
const Index = ({ passOn, onClose, onDeleted, refetch }) => {
  // Hook assignment.
  const [MutationCustomerAccountDelete, MutationCustomerAccountDeleteResponse] = useMutation(CustomerAccountDeleteMutation)
  const [MutationCustomerAccountDeleteAll, MutationCustomerAccountDeleteAllResponse] = useMutation(CustomerAccountDeleteAllMutation)

  // Return Component.
  return (

    <DeleteCard
      onClose={onClose}
      disabled={MutationCustomerAccountDeleteResponse.loading || MutationCustomerAccountDeleteAllResponse.loading}
      onConfirm={async () => {
        if (passOn?.isMulti) {
          // Parent delete - use customerAccountDeleteAll API
          try {
            const i = await MutationCustomerAccountDeleteAll({
              'variables': {
                'customerAccountIds': passOn?.customerAccountIds
              }
            })

            const _deleteStatus = i?.data?.CustomerAccountDeleteAll?.status

            toast(i?.data?.CustomerAccountDeleteAll?.message || 'Parent account deleted successfully')
            if (_deleteStatus?.includes?.('SUCCESSFUL')) onDeleted?.(passOn?.customerAccountIds || [])
            await refetch?.()
            return onClose?.()
          } catch {
            return toast('Something went wrong please try after some time.')
          }
        } else {
          // Individual delete 
          try {
            const i = await MutationCustomerAccountDelete({
              'variables': {
                'customerAccountId': passOn?.customerAccountId
              }
            })

            const _deleteStatus = i?.data?.CustomerAccountDelete?.status

            toast(i?.data?.CustomerAccountDelete?.message)
            if (_deleteStatus?.includes?.('SUCCESSFUL')) onDeleted?.([passOn?.customerAccountId].filter(Boolean))
            await refetch?.()
            return onClose?.()
          } catch {
            return toast('Something went wrong please try after some time.')
          }
        }
      }}
      isLoading={MutationCustomerAccountDeleteResponse.loading || MutationCustomerAccountDeleteAllResponse.loading} />
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'passOn': PropTypes.object,
  'onClose': PropTypes.func,
  'onDeleted': PropTypes.func,
  'refetch': PropTypes.func
}


/*
 * REDUX
 */
const _MapStateToProps = __state => ({ 'passOn': __state.PassOn })


/*
 * EXPORT
 */
export default connect(_MapStateToProps)(Index)
